module.exports = __webpack_public_path__ + "media/images/weather/211_night-d8f5e95060364f750bcb0977a5c21a01.png";